import React from 'react';
import TimeAgo from 'react-timeago';
import PieChart from "react-svg-piechart";
import {apiVariables} from '../utils/variables';
let pieData;

var dateFormat = require('dateformat');
/* eslint eqeqeq: "off" */




export class MainChart extends React.Component{
    constructor(props){
        super(props);
        this.state = {stats: null, time: Date.now()}
        this.handleRedirect = this.handleRedirect.bind(this)

    }
    handleRedirect(solutionName){
        window.location.href = "/state/" + solutionName
    }
    componentDidMount(){
        this.getStats();
        setInterval(() => this.getStats(), 60000);
    }

    getStats(){
        fetch(apiVariables.apiLink + 'solutionmonitor/overview/solutionStatistics?organization=' + encodeURIComponent(this.props.CurrentOrganization), { 
        method: 'get',
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        })
        .then((response) => response.json())
        .then((responseJson) => {
            this.setState({stats: responseJson})
            pieData = [
                {title: "Ok", value: parseInt(responseJson.document.statistics[0].okTotal, 10), color: "#5BC0DE"},
                {title: "Errors", value: parseInt(responseJson.document.statistics[0].errorTotal, 10), color: "#ff0000"}
            ];
            this.setState({stats: responseJson})
        });
        
    }
    
    render(){
        if(pieData == null || this.state.stats == null){
            this.getStats();
            return <h1>Fetching data {this.props.CurrentOrganization}</h1>
        }
        else{
            return (
            <div id="dashboard" className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12">
                      <div id="piechartContainer" className="row">
                      <div className="col-md-12 col-xs-12"><h1>{this.props.CurrentOrganization}</h1></div>
                        <div className="col-md-8 col-xs-12">
                        <div className="col-md-1 col-xs-12">
                            <label className="label label-danger">Error: {this.state.stats.document.statistics[0].errorTotal}</label><br />
                            <label className="label label-info">Ok: {this.state.stats.document.statistics[0].okTotal}</label>
                        </div>
                        <div className="col-md-11 col-xs-12">
                            <PieChart 
                            data={pieData} 
                            expandOnHover/>
                        </div>
                        </div>
                        <div className="col-md-4 col-xs-12">
                          <div className="table-responsive">
                            <table className="table table-striped table-condensed table-hover">
                              <thead>
                                <tr>
                                  <th className="text-center">Solution</th>
                                  <th className="text-center">Time on error</th>
                                </tr>
                              </thead>
                              <tbody className = "clickable">
                                {
                                this.state.stats.document.statistics[0].errorTotal != 0 ? 
                                this.state.stats.document.statistics.map((stat =>
                                    <tr key={stat.solutionName} onClick={() => this.handleRedirect(stat.solutionName)}>
                                        <td>{stat.solutionName.length > 18 ? stat.solutionName.substring(0, 18) + "..." :  stat.solutionName}</td>
                                        <td>{<TimeAgo date={stat.lastStateChange} />}</td>
                                    </tr>
                                )):
                                    <tr>
                                        <td>No errors</td>
                                    </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped table-condensed">
                          <thead>
                            <tr>
                              <th className="text-center">Timestamp</th>
                              <th className="text-center">Solution</th>
                              <th className="text-center">Error</th>
                              <th className="text-center">Server</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.stats.document.statistics[0].errorTotal != 0 ? 
                                this.state.stats.document.statistics.map((stat =>
                                    <tr key={stat.solutionName}>

                                        <td>{dateFormat(stat.lastStateChange, "dddd, dS mmmm, yyyy, h:MM:ss TT")}</td>
                                        <td>{stat.solutionName}</td>
                                        <td>{stat.lastMessage !== null ? stat.lastMessage.slice(0, 150): "No Last Message"}</td>
                                        <td>{stat.lastServer}</td>
                                        
                                    </tr>
                                )):
                                    <tr>
                                        <td>No errors</td>
                                    </tr>
                                }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            );
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/dashboard.js